import storage from 'redux-persist/lib/storage';
import { persistReducer } from 'redux-persist';

export default reducers => {
  const persistedReducer = persistReducer(
    {
      key: 'unimed',
      storage,
      whitelist: ['auth', 'beneficiarie'],
    },
    reducers
  );
  return persistedReducer;
};
